/** Supabase invite redirect — must match an entry in Supabase Auth → URL Configuration. */
export const INVITE_AUTH_CALLBACK_PATH = "/auth/callback/set-password";

export const SET_PASSWORD_PATH = "/set-password";
